import React, { createContext, useContext, useState } from "react";

const FreezeContext = createContext();

export const useFreeze = () => useContext(FreezeContext);

export const FreezeProvider = ({ children }) => {
  const [frozen, setFrozen] = useState(false);

  return (
    <FreezeContext.Provider value={{ frozen, setFrozen }}>
      {children}
    </FreezeContext.Provider>
  );
};
